import { observer } from "mobx-react-lite";
import { appSettings } from "core/config";
import { currencyString } from "core/lib";
import { User } from "core/models";
import AmountToPayStore from "core/stores/amount-to-pay.store";
import SquareLoader from "components/square-loader";
import PaymentButton from "./payment-button";

type AmountToPayBoxProps = {
    store: AmountToPayStore;
    retryAmountToPay: any,
    clearPayments: any
}

const AmountToPayBox = observer((props: AmountToPayBoxProps) => {
    const { store, retryAmountToPay, clearPayments } = props;
    const user = User.instance;

    if (store.hasError) {
        return (
            <>
                <h5>Total Amount Due</h5>

                <p className="error-message">
                    An error has occurred while retrieving amount to pay. {!store.isLoading && <span className="anchor" onClick={retryAmountToPay}>Retry</span>}
                </p>
            </>);
    }

    if (store.isLoading || !store.hasAmountToPayBeenSet) {
        return <SquareLoader />;
    }

    const amountToPay = store.amountToPay;
    const hasAmountToPay = !!amountToPay?.value;

    const showPaymentButton = appSettings.isEnabled.overPaying || hasAmountToPay;

    const amountValue = amountToPay
        ? currencyString(amountToPay.value, amountToPay.currencyCode)
        : "";

    return (
        <>
            <h5>Total Amount Due</h5>

            <p className="total-amount">
                {amountValue}
            </p>

            {showPaymentButton && <PaymentButton store={store} user={user} clearPayments={clearPayments} />}
        </>
    );
});

export default AmountToPayBox;
